<div class="block">
  <div class="container-fluid" style="max-width: 640px; width: 100%; padding: 0 32px;">
    <app-psp-container-wrapper>
      <div class="loadingSpinner" *ngIf="loading"></div>
      <div id="psp-container"></div>
      <div id="terms-of-service" style="display: none; text-align:center">
        {{'terms-of-service' | translate}}
        <a id="terms-of-service-link"> {{'terms-of-service-link-text' | translate}}</a>.
      </div>
    </app-psp-container-wrapper>
  </div>
  <div class="rowPadding" *ngIf="renderPaymentError">
    <div class="credit-card-error">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
          d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM342.627 169.373c-6.248-6.248-16.379-6.248-22.627 0L256 233.373l-64-64c-6.248-6.248-16.379-6.248-22.627 0s-6.248 16.379 0 22.627l64 64-64 64c-6.248 6.248-6.248 16.379 0 22.627s16.379 6.248 22.627 0l64-64 64 64c6.248 6.248 16.379 6.248 22.627 0s6.248-16.379 0-22.627l-64-64 64-64c6.248-6.248 6.248-16.379 0-22.627z"
        />
      </svg>
      <p>{{ 'error-something-went-wrong-title' | translate }}</p>
    </div>
  </div>

  <div class="rowPadding help-support">
    <button class="btn__link" (click)="openModal('credit-card-help-support-modal')">
      {{ 'error-help-and-support-button-text' | translate }}
    </button>
  </div>
</div>

<app-modal id="credit-card-help-support-modal">
  <app-credit-card-help-support
    [rentalPhoneNumber]="rentalPhoneNumber"
    [rentalPhoneNumberLink]="rentalPhoneNumberLink"
  ></app-credit-card-help-support>
</app-modal>
